import { combineReducers } from 'redux'
import auth from 'src/reducers/auth'
import message from 'src/reducers/message'
import changState from 'src/reducers/changState'
import registerForm from 'src/slices/register-form'
import { customerApi } from 'src/slices/hooks/customer'
import { globalApi } from 'src/slices/hooks/global'
import pagination from 'src/slices/pagination'
// import channel from 'src/reducers/channel'
// import rules from 'src/reducers/rules'

export default combineReducers({
  auth,
  message,
  changState,
  registerForm,
  pagination,
  // channel,
  // rules,
  [customerApi.reducerPath]: customerApi.reducer,
  [globalApi.reducerPath]: globalApi.reducer,
})
